class OVHeroPremium {

    constructor(){

        this.sections=document.querySelectorAll(".ov-hero-premium");

        if(!this.sections.length) return;

        this.items=[];

        this.sections.forEach(section=>{

            const image = section.querySelector(".ov-hero-premium__img");

            if(!image) return;

            const container = section.querySelector(".ov-hero-premium__image");

                if(!container) return;

                if(container.dataset.parallax !== "true") return;

            this.items.push({
                section,
                image,
                speed: Number(image.dataset.speed) || 0.3,
                startTop: section.offsetTop
            });

        });

        this.ticking=false;

        this.update=this.update.bind(this);

        window.addEventListener("scroll",()=>{

            if(!this.ticking){

                requestAnimationFrame(this.update);

                this.ticking=true;

            }

        },{passive:true});

        window.addEventListener("resize",this.update);

        this.update();

    }

    update() {

        this.items.forEach(item => {

            const rect = item.section.getBoundingClientRect();

            if (rect.bottom < 0 || rect.top > window.innerHeight) return;

            // Centro de la ventana
            const viewportCenter = window.innerHeight / 2;

            // Centro de la sección
            const sectionCenter = rect.top + (rect.height / 2);

            // Distancia entre ambos centros
            const distance = sectionCenter - viewportCenter;

            // Movimiento del parallax
            const y = -distance * item.speed;

            // Limitar el recorrido para que nunca se desplace demasiado
            const maxMove = 80;
            const offset = Math.max(-maxMove, Math.min(maxMove, y));

            item.image.style.transform = `translate3d(0, ${offset}px, 0)`;

        });

        this.ticking = false;

    }

}

/* ==========================
   Animaciones
========================== */

class OVAnimations{

    constructor(){

        this.items=document.querySelectorAll("[data-animation]");

        if(!this.items.length) return;

        if(window.matchMedia("(prefers-reduced-motion: reduce)").matches){

            this.items.forEach(el=>{

                el.classList.add("anim-visible");

            });

            return;

        }

        this.createObserver();

    }

    createObserver(){

        const observer=new IntersectionObserver((entries)=>{

            entries.forEach(entry=>{

                if(!entry.isIntersecting) return;

                const el=entry.target;

                const animation=el.dataset.animation;

                if(animation!=="none"){

                    el.classList.add("anim-init");

                    el.classList.add("anim-"+animation);

                    requestAnimationFrame(()=>{

                        requestAnimationFrame(()=>{

                            el.classList.add("anim-visible");

                        });

                    });

                }

                observer.unobserve(el);

            });

        },{

            threshold:0.20

        });

        this.items.forEach(el=>{

            observer.observe(el);

        });

    }

}

class OVCursorParallax {

    constructor(){

        if(window.matchMedia("(pointer: coarse)").matches){
            return;
        }

        this.items=document.querySelectorAll(".ov-hero-premium__image-inner[data-mouse='true']");

        this.items.forEach(item=>this.init(item));

    }

    init(item){

        let currentX=0;
        let currentY=0;

        let targetX=0;
        let targetY=0;

        const strength=Number(item.dataset.strength)||12;
        const smooth=Number(item.dataset.smooth)||8;

        item.closest(".ov-hero-premium").addEventListener("mousemove",(e)=>{

            const rect=item.getBoundingClientRect();

            const x=((e.clientX-rect.left)/rect.width)-0.5;
            const y=((e.clientY-rect.top)/rect.height)-0.5;

            targetX=x*strength;
            targetY=y*strength;

        });

        item.closest(".ov-hero-premium").addEventListener("mouseleave",()=>{

            targetX=0;
            targetY=0;

        });

        const animate=()=>{

            currentX+=(targetX-currentX)/smooth;
            currentY+=(targetY-currentY)/smooth;

            item.style.transform=`translate3d(${currentX}px,${currentY}px,0)`;

            requestAnimationFrame(animate);

        };

        animate();

    }

}

/* ==========================
   Init
========================== */

function initOVHeroPremium(){

    new OVHeroPremium();

    new OVAnimations();

    new OVCursorParallax();

}

document.addEventListener("DOMContentLoaded", initOVHeroPremium);

document.addEventListener("shopify:section:load", initOVHeroPremium);